const PHRASES = ["Ceremony", "Story", "Voice", "Alyth, Perthshire", "Written From Scratch", "Spoken With Presence"];

export const Marquee = () => {
  const row = [...PHRASES, ...PHRASES, ...PHRASES];
  return (
    <div className="overflow-hidden border-y border-gold/30 bg-creamdeep py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display px-8 text-2xl italic text-forest/70 sm:text-3xl">{p}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
